import { uniq } from 'lodash';

import { useUiData } from '../../lib/hooks';
import useContentTreeNodes from '../ui/useContentTreeNodes';
import useCurriculumIdsWithProgress from './useCurriculumIdsWithProgress';

const useCurriculaWithProgressFiltered = (...args) => {
	const { isPending: uiIsPending, isError: uiIsError, data: { curricula } } = useUiData(['curricula']);
	const nodeStatuses = useContentTreeNodes((uiIsPending || uiIsError) ? [] : curricula.map((c) => [c.id, '']));
	const metricStatuses = useCurriculumIdsWithProgress(...args);

	const isPending = uiIsPending || metricStatuses.some(s => s.isPending) || nodeStatuses.some(s => s.isPending);
	const isError = uiIsError || metricStatuses.some(s => s.isError) || nodeStatuses.some(s => s.isError);
	const data = isPending || isError ? null : (() => {
		const curriculumIdsWithSequence = nodeStatuses.map((s) => s.data).filter(Boolean).map((d) => d.curriculumId);
		const curriculumIdsWithProgress = uniq(metricStatuses.flatMap(s => s.data.curriculaWithProgress));
		return curricula.filter(c => curriculumIdsWithSequence.includes(c.id) && curriculumIdsWithProgress.includes(c.id));
	})();

	return { isPending, isError, data };
};
export default useCurriculaWithProgressFiltered;
